import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { GuideAssistant } from "./GuideAssistant";
import { clearLocalSession } from "../../../shared/auth";
import { localKv } from "../lib/kv";
import type { ImpersonationMeta } from "../lib/impersonation";

type Props = {
  userName: string;
  loggedIn?: boolean;
  isAdmin?: boolean;
  impersonation?: ImpersonationMeta | null;
  onDisconnect?: () => void;
  onLogout: () => void;
};

export default function Shell({
  userName,
  loggedIn = true,
  isAdmin = false,
  impersonation = null,
  onDisconnect,
  onLogout,
}: Props) {
  const navigate = useNavigate();

  const logout = async () => {
    await clearLocalSession(localKv);
    onLogout();
  };

  return (
    <div className="hermes-shell">
      <div className="street-glow" aria-hidden />
      {impersonation ? (
        <div className="impersonation-banner" role="status">
          <span>
            Conectado como <strong>{impersonation.targetEmail}</strong>
            {impersonation.testMode ? " · modo pruebas" : " · en vivo"}
          </span>
          <button type="button" className="rail-out" onClick={() => onDisconnect?.()}>
            Desconectar
          </button>
        </div>
      ) : null}
      <header className="hermes-mast">
        <Link to="/" className="hermes-brand">
          <span className="hermes-brand-mark">HERMES</span>
          <span className="hermes-brand-sub">salidas con nombre propio</span>
        </Link>
        <p className="hermes-user">
          Hola, <strong>{userName || "explorador"}</strong>
        </p>
        <nav className="hermes-rail" aria-label="Principal">
          <NavLink to="/" end>
            Planes
          </NavLink>
          <NavLink to="/surprise">Sorpresa</NavLink>
          <NavLink to="/routes">Rutas</NavLink>
          <NavLink to="/perfil">Perfil</NavLink>
          {isAdmin ? <NavLink to="/admin">Admin</NavLink> : null}
          {loggedIn ? (
            <button type="button" className="rail-out" onClick={() => void logout()}>
              Salir
            </button>
          ) : (
            <button type="button" className="rail-out" onClick={() => navigate("/login")}>
              Entrar
            </button>
          )}
        </nav>
      </header>
      <main className="hermes-stage">
        <Outlet />
      </main>
      <footer className="hermes-foot">
        <span>HERMES</span>
        <span>mapa · ánimo · calle</span>
      </footer>
      <GuideAssistant />
    </div>
  );
}
